import {h, JSX} from 'preact'
import {Modal} from './Modal'
import {DiscountsSection, DiscountsSectionProps} from './DiscountsSection';
import classNames from 'classnames';

export interface DiscountsModalProps {
    title: string;
    show: boolean;
    isSaveDisabled?: boolean;
    toggleModal: () => void;
    onSave?: () => void;
    closeLabel?: string;
    addLabel?: string;
    discounts: DiscountsSectionProps;
}

export const DiscountsModal = (props: DiscountsModalProps): JSX.Element => (
    <Modal
        show={props.show}
        toggleModal={props.toggleModal}
        title={props.title}
        hasCloseButton
    >
        <div class="px-8 py-6">
            <DiscountsSection {...props.discounts} />
        </div>
        <div class='flex shrink justify-end items-center border-t px-8 py-6'>
            <div class='flex gap-2.5'>
                {props.closeLabel && (
                    <button onClick={props.toggleModal} class='btn btn-border p-4 text-base leading-[14px]'>
                        {props.closeLabel}
                    </button>
                )}
                {props.addLabel && props.addLabel && (
                    <button
                        onClick={props.onSave}
                        disabled={props.isSaveDisabled}
                        class={classNames(
                            'btn p-4 text-base leading-[14px]',
                            props.isSaveDisabled ? 'btn-disabled' : 'btn-light-blue'
                        )}
                    >
                        {props.addLabel}
                    </button>
                )}
            </div>
        </div>
    </Modal>
);
